// extracted by mini-css-extract-plugin
module.exports = {"listingsListTitle":"listings-title_listingsListTitle__7LA4R"};